/**
 * Server CSV: exclude rows flagged in Cross-source vs filters column.
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FC } from 'react';

import { Switch } from '@/components/ui';

interface CsvExportCrossSourceExcludeControlProps {
  checked: boolean;
  disabled: boolean;
  onCheckedChange: (v: boolean) => void;
}

export const CsvExportCrossSourceExcludeControl: FC<
  CsvExportCrossSourceExcludeControlProps
> = ({ checked, disabled, onCheckedChange }) => (
  <div className="flex items-start gap-2.5 rounded-md border border-border/30 bg-muted/5 p-2.5">
    <Switch
      id="csv-export-exclude-cross-source"
      checked={checked}
      disabled={disabled}
      onCheckedChange={onCheckedChange}
      aria-label="Drop rows with a cross-source warning"
    />
    <div className="min-w-0 flex-1 space-y-0.5">
      <label
        htmlFor="csv-export-exclude-cross-source"
        className="cursor-pointer text-xs font-medium leading-tight text-foreground"
      >
        Drop rows with a cross-source warning
      </label>
      <p className="text-[11px] leading-snug text-muted-foreground">
        Leave this off to export every filtered row with the “Cross-source vs filters” column when
        you include it—warnings appear there when they apply. Turn on to remove those rows from the
        file and omit that column (remaining rows would otherwise have empty cells there). Only for
        Phone with limit All (full server export)—not capped “current view” downloads.
      </p>
    </div>
  </div>
);
